<mat-toolbar color="accent">
	<mat-toolbar-row>
		<span>Enter New Patient Details</span>
		<span class="spacer"></span>
		<span>
			<button type="button" aria-label="Go Back" mat-raised-button (click)="handleBack()">
				<mat-icon>chevron_left</mat-icon>
			</button>
		</span>
	</mat-toolbar-row>
</mat-toolbar>

<app-patient-form 
	[statuses]="statuses" 
	[initializeTestData]="false" 
	[filterFields]="true"
	(onSubmit)="onSubmit( $event )" 
	[hospitals]="hospitals" 
	[initialValues]="initialValues">
</app-patient-form>